export default __webpack_public_path__ + "static/media/kk.f79d596c.jpg";